import React from "react";
import "./MarqueeSlider.css";

import eagleUAEColor2 from "../../assets/images/serviceSlider/eagle-uae-color2.png";
import eagleUpWings2 from "../../assets/images/serviceSlider/eagle-up-wings2.png";
import environmentProtectionDept from "../../assets/images/serviceSlider/environment-protection-department2.png";
import municipility2 from "../../assets/images/serviceSlider/municipility2.png";
import publicServiceDept from "../../assets/images/serviceSlider/public-service-department2.png";
import tasHeel2 from "../../assets/images/serviceSlider/tas-heel2.png";
import teamRocket2 from "../../assets/images/serviceSlider/team-rocket2.png";


const images = [
    eagleUAEColor2,
    eagleUpWings2,
    environmentProtectionDept,
    municipility2,
    publicServiceDept,
    tasHeel2,
    teamRocket2,
];

const MarqueeSlider = () => {
    return (
        <div className="marquee-container">
            <div className="marquee">
                {images.map((image, index) => (
                    <img key={index} src={image} alt={`Slide ${index + 1}`} />
                ))}
                {/* Duplicate images for seamless looping */}
                {images.map((image, index) => (
                    <img key={`duplicate-${index}`} src={image} alt={`Slide Duplicate ${index + 1}`} />
                ))}
            </div>
        </div>
    );
};

export default MarqueeSlider;

